import * as actionTypes from "../actions/actionTypes";

const initialState = {
  freeSlots: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FREE_SLOTS:
      return {
        ...state,
        freeSlots: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
